import { render, staticRenderFns } from "./AvailabilityReport.vue?vue&type=template&id=637da87e&"
import script from "./AvailabilityReport.js?vue&type=script&lang=js&"
export * from "./AvailabilityReport.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports